module.exports = __webpack_public_path__ + "img/all_for_one.cover.40c8c373.jpg";